import { NgModule } from '@angular/core';
import { SwiperDirective } from './swiper/swiper.directive';
import { ViewContainerRefDirective } from "./view-container-ref/view-container-ref.directive";

@NgModule({
  imports: [],
  declarations: [
    SwiperDirective,
    ViewContainerRefDirective,
  ],
  exports: [
    SwiperDirective,
    ViewContainerRefDirective,
  ],
})
export class DirectivesModules {}
